module.exports = __webpack_public_path__ + "static/img/c3.d17b49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c3.png
// module id = SlHJ
// module chunks = 0